import React, { useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { ColoredCircularProgress } from 'styles/common';

import { ALERT_MESSAGES } from 'constants/ProjectConstants';

import { getFeedbackDetailsById } from 'services/continuousFeedback';
import { showErrorSnackbar } from 'services/snackbar';

import ViewRequestedFeedback from './ViewRequestedFeedback';

const CircularProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const ShowRequestedFeedback = ({ handleClose, feedbackId, loggedInEmployee, handleResetData }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [requestFeedbackDetails, setRequestFeedbackDetails] = useState(null);

  const getData = () => {
    setLoading(true);
    getFeedbackDetailsById({ feedbackId })
      .then((res) => {
        setRequestFeedbackDetails(res);
      })
      .catch(() => {
        dispatch(showErrorSnackbar(ALERT_MESSAGES.GENERIC.FAILURE));
        handleClose();
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (feedbackId) {
      getData();
    }
  }, []);

  return !loading && requestFeedbackDetails !== null ? (
    <ViewRequestedFeedback
      handleClose={handleClose}
      requestFeedbackDetails={requestFeedbackDetails}
      loggedInEmployee={loggedInEmployee}
      handleResetData={handleResetData}
    />
  ) : (
    <CircularProgressContainer>
      <ColoredCircularProgress />
    </CircularProgressContainer>
  );
};

export default ShowRequestedFeedback;
